/**
 * Hobbes Avatar — used in chat header, messages, and review view.
 * Shows org logo when available, falls back to Hobbes icon.
 */

import React from 'react';
import { cn } from '@/lib/utils';

const HOBBES_ICON = 'https://storage.googleapis.com/hobbes-assets/Favicon_Dark.svg';

export const HobbesAvatar: React.FC<{
  size?: 'sm' | 'md' | 'lg';
  logoUrl?: string | null;
}> = ({ size = 'sm', logoUrl }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  };

  if (logoUrl) {
    return (
      <div className={cn('flex-shrink-0 rounded-full overflow-hidden', sizeClasses[size])}>
        <img src={logoUrl} alt="Company logo" className="w-full h-full object-cover" />
      </div>
    );
  }

  const imgSizes = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-7 h-7',
  };
  return (
    <div
      className={cn(
        'flex-shrink-0 rounded-full bg-secondary flex items-center justify-center',
        sizeClasses[size]
      )}
    >
      <img src={HOBBES_ICON} alt="Hobbes" className={cn(imgSizes[size], 'dark:invert')} />
    </div>
  );
};
